import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Typography } from 'interfaces/typography';
import { 
    savePlatformDispositions,
    clearPlatformDispositions,
    resetToSaved,
    selectCurrentDispositions,
    selectSavedDispositions,
    selectIsSaving,
    selectHasUnsavedChanges
} from 'lib/redux/settings/platformDispositionsSlice';

export function SaveControls() {
    const dispatch = useDispatch();
    const platform = useSelector((state: RootState) => state.autodialerSettings.selectedPlatform);
    const currentDispositions = useSelector(selectCurrentDispositions(platform!));
    const savedDispositions = useSelector(selectSavedDispositions(platform!));
    const isSaving = useSelector(selectIsSaving(platform!));
    const hasUnsavedChanges = useSelector(selectHasUnsavedChanges(platform!));

    const handleSave = () => {
        if (platform) {
            savePlatformDispositions(dispatch, platform, currentDispositions);
        }
    };

    const handleReset = () => {
        if (platform) {
            dispatch(resetToSaved(platform));
        }
    };

    const handleClear = () => {
        if (platform) {
            clearPlatformDispositions(dispatch, platform);
        }
    };

    return (
        <div className="flex justify-between items-center pt-4 border-t border-gray-200">
            <div className="flex space-x-3">
                <button
                    onClick={handleSave}
                    disabled={isSaving || !hasUnsavedChanges}
                    className={`px-6 py-2 rounded-md transition-colors ${
                        hasUnsavedChanges && !isSaving
                            ? 'bg-blue-600 hover:bg-blue-700 text-white'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                >
                    <Typography variant="mediumParagraph" color={hasUnsavedChanges && !isSaving ? "white" : "#6B7280"} fontWeight="500">
                        {isSaving ? 'Saving...' : 'Save Changes'}
                    </Typography>
                </button>

                <button
                    onClick={handleReset}
                    disabled={isSaving || !hasUnsavedChanges}
                    className={`px-6 py-2 rounded-md transition-colors ${
                        hasUnsavedChanges && !isSaving
                            ? 'bg-gray-600 hover:bg-gray-700 text-white'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                >
                    <Typography variant="mediumParagraph" color={hasUnsavedChanges && !isSaving ? "white" : "#6B7280"} fontWeight="500">
                        Reset
                    </Typography>
                </button>
            </div>

            <button
                onClick={handleClear}
                disabled={isSaving || (savedDispositions.length === 0)}
                className={`px-6 py-2 rounded-md transition-colors ${
                    savedDispositions.length > 0 && !isSaving
                        ? 'bg-red-600 hover:bg-red-700 text-white'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
            >
                <Typography variant="mediumParagraph" color={savedDispositions.length > 0 && !isSaving ? "white" : "#6B7280"} fontWeight="500">
                    {isSaving ? 'Clearing...' : 'Clear All Saved'}
                </Typography>
            </button>
        </div>
    );
}